import { ApiError } from 'src/config/request'
import { MentionItem as MentionItemProps } from '../../components/mentionList'

export type ExtractMentionsFromHTMLResponse = { id: string; label: string }[]

export type ParseMentionsParams = {
  text: string
  mentions: MentionItem[]
}

type MentionItem = {
  id: string
  label: string
}

export type GetEditorExtensionParams = {
  mentionConfig?: {
    appendTo?: () => Element | null
    zIndex?: number
  }
  communityId?: string
  onMentionSuccess?: ({ query, length }: OnSuccessParams) => void
  onMentionError?: ({ query, error }: OnErrorParams) => void
  onMentionClick?: (mention: MentionItemProps) => void
}

export type FetchMentionsParams = {
  communityId: number
  searchText: string
  size: number
  language?: string
  callback: Callback
  onSuccess?: ({ query, length }: OnSuccessParams) => void
  onError?: ({ query, error }: OnErrorParams) => void
}

export type OnSuccessParams = {
  query: string
  length?: number
}

export type OnErrorParams = {
  query: string
  error?: ApiError
}

type Mention = {
  id: number | string
  label?: string
  reference?: string
  image?: string
  type?: string
}

type Callback = (mentions: Mention[]) => void

export type MentionItemForHTML = {
  tag: string
  ucode?: string
  name?: string
  failed?: boolean
  failureReason?: FailureReason
}

export type ConvertMentionToHTMLParams = {
  text: string
  htmlTag?: 'a' | 'span'
  mentions?: MentionItemForHTML[]
}

export type ConvertMentionToRawTextParams = {
  text: string
  mentions?: {
    tag: string
    ucode?: string
    name?: string
    failed?: boolean
    failureReason?: FailureReason
  }[]
}

export enum FailureReason {
  ERROR = 'ERROR',
  NOT_FOUND = 'NOT_FOUND'
}

export type RenderMentionHTMLTagParams = {
  name?: string
  ucode?: string
}

export enum RequestState {
  NO_RESULTS = 'NO_RESULTS'
}

export type UrlPathParams = {
  lang: string
}
